import { defineMessage, defineMessages } from 'react-intl';
const PAID_SUBSCRIPTION_TIERS = ['pro', 'max'];
export const isPaidSubscriptionTier = (tier) => PAID_SUBSCRIPTION_TIERS.some((paidSubscriptionTier) => paidSubscriptionTier === tier);
const tierFullLabels = defineMessages({
    viewer: {
        description: 'Display name for the Enterprise Viewer subscription tier',
        defaultMessage: 'Enterprise Viewer',
        id: '45182ab8e7',
    },
    pro: {
        description: 'Display name for the Enterprise Pro subscription tier',
        defaultMessage: 'Enterprise Pro',
        id: '6322684844',
    },
    max: {
        description: 'Display name for the Enterprise Max subscription tier',
        defaultMessage: 'Enterprise Max',
        id: '5ef6af8a9d',
    },
});
export const enterpriseTierFullLabels = {
    ...tierFullLabels,
    // TODO(ENT-6348): Remove the Basic alias in the final cleanup.
    basic: tierFullLabels.viewer,
};
const tierShortLabels = {
    viewer: defineMessage({
        description: 'Display name for the Enterprise Viewer subscription tier',
        defaultMessage: 'Viewer',
        id: 'd3d59501c0',
    }),
    pro: defineMessage({
        description: 'Display name for the Enterprise Pro subscription tier',
        defaultMessage: 'Pro',
        id: '0ec3fa666d',
    }),
    max: defineMessage({
        description: 'Display name for the Enterprise Max subscription tier',
        defaultMessage: 'Max',
        id: 'aae7502631',
    }),
};
export const enterpriseTierShortLabels = {
    ...tierShortLabels,
    // TODO(ENT-6348): Remove the Basic alias in the final cleanup.
    basic: tierShortLabels.viewer,
};
// Basic and Viewer are the same tier, so changing spelling is never an upgrade.
const tierRank = {
    basic: 0, // TODO(ENT-6348): Remove in the final cleanup.
    viewer: 0,
    pro: 1,
    max: 2,
};
export const isSubscriptionTier = (tier) => {
    return Object.keys(tierRank).includes(tier);
};
export const isTierUpgrade = (from, to) => {
    return tierRank[from] < tierRank[to];
};
const ENTERPRISE_TIERS = ['enterprise_pro', 'enterprise_max'];
export const isEnterpriseTier = (tier) => {
    return ENTERPRISE_TIERS.includes(tier);
};
const ENTERPRISE_TIER_TO_SUBSCRIPTION_TIER = {
    enterprise_pro: 'pro',
    enterprise_max: 'max',
};
export const getSubscriptionTierForEnterpriseTier = (tier) => {
    return ENTERPRISE_TIER_TO_SUBSCRIPTION_TIER[tier];
};
//# sourceMappingURL=enterpriseTiers.js.map